import styled from "styled-components";
import theme from "../../style/theme";

interface Props {
}

export const RoutingServiceVehicleTableHeader: React.FC<Props> = ({}) => {
    return (
        <TableRow>
            <TableHead>
                <Label>배송원</Label>
            </TableHead>
            <TableHead>
                <Label>근무 시작 시간</Label>
            </TableHead>
            <TableHead>
                <Label>근무 종료 시간</Label>
            </TableHead>
            <TableHead>
                <Label>차량 선택(최대 용적량)</Label>
            </TableHead>
            <TableHead>
                <Label>근무 시작지 주소</Label>
            </TableHead>
            <TableHead>
                <Label>근무 종료지 주소</Label>
            </TableHead>
        </TableRow>
    );
};

const TableRow = styled.tr``;

const TableHead = styled.th`
  text-align: left;
`;

const Label = styled.div`
  margin: 0 4px 0 16px;
  padding: 0 0 0 2px;
  color: ${theme.palette.primitives.gray400};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
